import {tfUpdateOrder, UpdateOrder} from "./amend/UpdateOrderComponent";
import {
    equityActiveOrderList,
    EquityActiveOrderList,
    equityInactiveOrderList,
    EquityInactiveOrderList,
    mobileActiveOrderList,
    MobileActiveOrderList,
    mobileInactiveOrderList,
    MobileInactiveOrderList,
    OptionActiveOrderList,
    optionActiveOrderList,
    OptionInactiveOrderList,
    optionInactiveOrderList
} from "./list/OrderListComponent";
import {orderEntryLink, OrderEntryLink} from "./link/OrderEntryLinkComponents";
import {tfOrders, TfOrders} from "./orders/OrdersComponent";
import {childOrdersDialog, ChildOrdersDialog} from "./child-orders-dialog/ChildOrdersDialogComponent";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.components`;

    return angular.module(moduleName, [])
                  .component(UpdateOrder, tfUpdateOrder())
                  .component(EquityActiveOrderList, equityActiveOrderList())
                  .component(EquityInactiveOrderList, equityInactiveOrderList())
                  .component(MobileActiveOrderList, mobileActiveOrderList())
                  .component(MobileInactiveOrderList, mobileInactiveOrderList())
                  .component(OptionActiveOrderList, optionActiveOrderList())
                  .component(OptionInactiveOrderList, optionInactiveOrderList())
                  .component(OrderEntryLink, orderEntryLink())
                  .component(TfOrders, tfOrders())
                  .component(ChildOrdersDialog, childOrdersDialog())
                  .name;
}
